<div class="payment-status-badge" [ngClass]="'payment-' + status">
  <ion-icon name="card-outline" class="card-icon"></ion-icon>
  <span class="p-4 fs-11 font-semibold text-uppercase">
    {{ 'pages.fund-cash.payment-status.' + status | translate }}
  </span>
</div>
